import React from 'react';
import {withDynamicComponents} from 'higher-order-components';
import CarLineup from '../../containers/car-lineup';
import CarLineupFilter from '../../blocks/car-lineup-filter';

const CarLineupBlock = props => <CarLineup {...props} />;
CarLineupBlock.displayName = 'CarLineup';

export default withDynamicComponents({
  componentWhitelist: [
    CarLineupFilter
  ],
  mapInputToOutput: [
    // ['passengerCarFilters', 'passengerCarFilters'],
    // ['models', 'models'],
  ],
})(CarLineupBlock);



// WEBPACK FOOTER //
// ./src/blocks/car-lineup/index.jsx